import { StockIndicator } from "@coworker/app/src/features/stock";
import { ItemExpectedDeliveryResponse } from "../../../shared/types/itemExpectedDeliveryResponse";
import { FixaSkeleton } from "../../../shared/wrappers/FixaSkeleton/FixaSkeleton";
import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import DeliveryTruckIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/DeliveryTruckIconPath";
import { Trans } from "@coworker/locales";
import useFormatter from "@coworker/app/src/hooks/useFormatter";
import ProductCardCss from "./product-card.module.css";

interface StockAndInDeliveryInfoProps {
  available: number;
  elevated: number | null;
  color: string | undefined;
  isStockLoading: boolean;
  itemDeliveryData: ItemExpectedDeliveryResponse | undefined;
  isDeliveryDataLoading: boolean;
}

export const StockAndInDeliveryInfo = ({
  available,
  elevated,
  color,
  isStockLoading,
  itemDeliveryData,
  isDeliveryDataLoading,
}: StockAndInDeliveryInfoProps) => {
  const { formatDateShort } = useFormatter();

  return (
    <>
      {isStockLoading || isDeliveryDataLoading ? (
        <FixaSkeleton height="24px" width="175px" />
      ) : (
        <div className={ProductCardCss["stock-and-delivery"]}>
          <div className={ProductCardCss["stock-info"]}>
            <StockIndicator
              color={color}
              size={8}
              marginRight={4}
              marginTop={2}
            />
            {available?.toString() !== "" ? (
              available
            ) : (
              <Trans>noStockInfoString</Trans>
            )}
            &nbsp;
            {elevated !== null && `(${elevated})`}
          </div>
          {itemDeliveryData?.deliveryDate && (
            <div className={ProductCardCss["delivery-info"]}>
              <FixaSSRIcon
                paths={DeliveryTruckIconPath}
                className={ProductCardCss["delivery-icon"] as string}
              />
              <span>
                <Trans>indeliveryString</Trans>&nbsp;
                {formatDateShort(itemDeliveryData?.deliveryDate)}
                {itemDeliveryData?.deliveryQuantity && (
                  <>
                    &nbsp;- {itemDeliveryData.deliveryQuantity}&nbsp;
                    <Trans>piecesString</Trans>
                  </>
                )}
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
};
